/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import LostDataModal from "../../../../../SharedComponents/LostDataModal";

import "./AddDRPFormLayout.scss";
import { CCB_FORM_ID } from "../../CriminalDisclosureForm/constants";
import { useSelector } from "react-redux";
import CustomTimeLine from "../CustomTimeLine";

const AddDRPFormLayout = ({
  updateCCBForm,
  header,
  section,
  children,
  activeStep,
  notApplicable = [],
  notPassed,
  steps,
  setCustomTimelineSteps,
  description,
}) => {
  const { showLogoutModal } = useSelector((state) => state.logoutModal);
  const [showBackModal, setShowBackModal] = useState(false);

  const handleCloseBackModal = () => setShowBackModal(false);

  const handleBackClick = () => {
    updateCCBForm(CCB_FORM_ID.DRP_SUMMARY, { isReset: true });
    handleCloseBackModal();
  };

  const handleShowBackModal = () => {
    if (showLogoutModal) {
      setShowBackModal(true);
    } else {
      handleBackClick();
    }
  };

  return (
    <>
      <div className="drp-layout-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="drp-layout-return">
              <span role="presentation" onClick={handleShowBackModal}>
                <span className="icon-xs icon-caret-spin-left"></span>
                <strong id="drp-return-disclosure">Return To Disclosure</strong>
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="drp-layout-eyebrow">
              <strong id={`drp-eyebrow-text`}>{header}</strong>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <label>
              <h1 id="drp-header">Disclosure Reporting Page (DRP)</h1>
            </label>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 section-details-container">
            <div className="drp-layout-section">
              <span id="drp-section">{section}</span>
            </div>
            <div className={!section ? "guide with-padding" : "guide"}>
              * = Required
            </div>
          </div>
        </div>

        <CustomTimeLine
          activeStep={activeStep}
          steps={steps}
          notApplicable={notApplicable}
          setCustomTimelineSteps={setCustomTimelineSteps}
          notPassed={notPassed}
        />

        {description ? (
          <div className="row">
            <div className="col-md-12">
              <span className="drp-layout-description">{description}</span>
            </div>
          </div>
        ) : null}

        {children}
        <LostDataModal
          isOpen={showBackModal}
          handleClose={handleCloseBackModal}
          handleProceed={handleBackClick}
        />
      </div>
    </>
  );
};

export default AddDRPFormLayout;
